module.exports = __webpack_public_path__ + "static/Rekki-2f714f6b76d50e907f53376ca87870a2.jpg";